import React from 'react';
import { NotificationDataType } from './common/types';
import { DisappearingNotificationType } from './common/components/DisappearingNotification/DisappearingNotification';

export class AppContextType {
  constructor(params: AppContextType) {
    this.notificationData = params.notificationData;
    this.setNotificationData = params.setNotificationData;
    this.disappearingNotification = params.disappearingNotification;
    this.setDisappearingNotification = params.setDisappearingNotification;
  }

  notificationData: NotificationDataType | undefined;

  setNotificationData: React.Dispatch<React.SetStateAction<NotificationDataType | undefined>>;

  disappearingNotification: DisappearingNotificationType | undefined;

  setDisappearingNotification: React.Dispatch<React.SetStateAction<DisappearingNotificationType | undefined>>;
}

const AppContext = React.createContext<AppContextType | null>(null);

export default AppContext;
